/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleMappingCount200Response
 */
export interface RoleMappingCount200Response {
    /**
     * 
     * @type {number}
     * @memberof RoleMappingCount200Response
     */
    count?: number;
}

/**
 * Check if a given object implements the RoleMappingCount200Response interface.
 */
export function instanceOfRoleMappingCount200Response(value: object): value is RoleMappingCount200Response {
    return true;
}

export function RoleMappingCount200ResponseFromJSON(json: any): RoleMappingCount200Response {
    return RoleMappingCount200ResponseFromJSONTyped(json, false);
}

export function RoleMappingCount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleMappingCount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function RoleMappingCount200ResponseToJSON(json: any): RoleMappingCount200Response {
    return RoleMappingCount200ResponseToJSONTyped(json, false);
}

export function RoleMappingCount200ResponseToJSONTyped(value?: RoleMappingCount200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

